export class OrganisationUserModel {
    public organisationUserId: string
    public securityGroupId: string;
    public organisationId: string;
    public statusCode: string;
    public firstName: string;
    public lastName: string;
    public primaryContactFlag: boolean;
    public primaryFlag: boolean;
}